<ng-container *transloco="let t; read: 'RESTAURANT_FLUIDITE_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <div class="left"></div>
      <h1>{{ t('TITLE') }}</h1>
      <ion-button (click)="dismissModal()" fill=" none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
  <ion-content>
    <swiper [pagination]="{ dynamicBullets: true, dynamicMainBullets: 3 }" [centeredSlides]="true" [initialSlide]="sliderOptions.initialSlide">
      [spaceBetween]="10">
      <ng-container *ngFor="let restaurant of restaurants">
        <ng-template swiperSlide>
          <div class="fluidite-slide">
            <h2>{{ restaurant.title }}</h2>
            <app-restaurant-hours
              *ngIf="!restaurant!.isExceptionallyClosed && restaurant!.closedAt && restaurant!.openedAt"
              [isOpen]="restaurant.isOpen"
              [openedAt]="restaurant.openedAt"
              [closedAt]="restaurant.closedAt"
              class="text-center mt-4"
            ></app-restaurant-hours>
            <div class="spacer"></div>
            <div class="mt-48" *ngLet="restaurant.fluiditeDetailsDS$ | async as fluiditeDS">
              <div class="graph-loader-error-container" *ngIf="fluiditeDS.loading || fluiditeDS.error">
                <app-pre-loader *ngIf="fluiditeDS.loading"></app-pre-loader>
                <app-error-container *ngIf="fluiditeDS.error" icon="stats-chart-outline" [errorKey]="'FluiditeNotSupported'"> </app-error-container>
              </div>
              <app-fluidite-graph
                *ngIf="!fluiditeDS.error && !fluiditeDS.loading"
                [isOpen]="restaurant.isOpen"
                [currentOccupation]="restaurant.fluidite"
                [fluiditeDetails]="fluiditeDS.data"
              >
              </app-fluidite-graph>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </swiper>
  </ion-content>
</ng-container>
